// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Modal$OrcaPaymentPage from "./Components/Modal.bs.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as HyperLogger$OrcaPaymentPage from "./hyper-log-catcher/HyperLogger.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "./Utilities/LoggerUtils.bs.js";
import * as PaymentError$OrcaPaymentPage from "./Types/PaymentError.bs.js";
import * as UtilityHooks$OrcaPaymentPage from "./Hooks/UtilityHooks.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "./Utilities/PaymentHelpers.bs.js";

function ThreeDSAuth(props) {
  var match = React.useState(function () {
        return false;
      });
  var match$1 = React.useState(function () {
        return true;
      });
  var setloader = match$1[1];
  var threeDsAuthoriseUrl = React.useRef("");
  var match$2 = React.useState(function () {
        return 600000.0;
      });
  var setExpiryTime = match$2[1];
  var expiryTime = match$2[0];
  var logger = HyperLogger$OrcaPaymentPage.make(undefined, {
        TAG: "Elements",
        _0: "Payment"
      }, undefined, undefined, undefined, undefined);
  var handleFrictionLess = function () {
    var ele = document.querySelector("#threeDsAuthDiv");
    if (ele == null) {
      return ;
    }
    var form1 = Utils$OrcaPaymentPage.makeForm(ele, threeDsAuthoriseUrl.current, "3dsFrictionLess");
    form1.submit();
  };
  var eventsToSendToParent = [
    "confirmParams",
    "poll_status",
    "openurl_if_required"
  ];
  UtilityHooks$OrcaPaymentPage.useSendEventsToParent(eventsToSendToParent);
  React.useEffect((function () {
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                  "iframeMountedCallback",
                  true
                ]]);
          var handle = function (ev) {
            var json = Utils$OrcaPaymentPage.safeParse(ev.data);
            var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
            if (!Core__Option.isSome(dict["fullScreenIframeMounted"])) {
              return ;
            }
            var metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata");
            var metaDataDict = Core__Option.getOr(Core__JSON.Decode.object(metadata), {});
            var paymentIntentId = Utils$OrcaPaymentPage.getString(metaDataDict, "paymentIntentId", "");
            var publishableKey = Utils$OrcaPaymentPage.getString(metaDataDict, "publishableKey", "");
            var sdkAuthorization = Utils$OrcaPaymentPage.getOptionString(metaDataDict, "sdkAuthorization");
            logger.setClientSecret(paymentIntentId);
            logger.setMerchantId(publishableKey);
            var headersDict = Core__Option.getOr(Core__JSON.Decode.object(Utils$OrcaPaymentPage.getJsonObjectFromDict(metaDataDict, "headers")), {});
            threeDsAuthoriseUrl.current = Utils$OrcaPaymentPage.getString(Core__Option.getOr(Core__JSON.Decode.object(Utils$OrcaPaymentPage.getJsonObjectFromDict(metaDataDict, "threeDSData")), {}), "three_ds_authorize_url", "");
            var headers = Utils$OrcaPaymentPage.convertDictToArrayOfKeyStringTuples(headersDict);
            var threeDsMethodComp = Utils$OrcaPaymentPage.getString(metaDataDict, "3dsMethodComp", "U");
            Core__Promise.$$catch(PaymentHelpers$OrcaPaymentPage.threeDsAuth(paymentIntentId, logger, threeDsMethodComp, Object.fromEntries(headers), Caml_option.some(sdkAuthorization)).then(function (json) {
                      var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
                      if (Core__Option.isSome(dict["error"])) {
                        var errorObj = PaymentError$OrcaPaymentPage.itemToObjMapper(dict);
                        Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                                "fullscreen",
                                false
                              ]]);
                        Utils$OrcaPaymentPage.postFailedSubmitResponse(errorObj.error.type_, errorObj.error.message);
                        return Promise.resolve(null);
                      }
                      var creq = Utils$OrcaPaymentPage.getString(dict, "challenge_request", "");
                      var challengeRequestKey = Utils$OrcaPaymentPage.getString(dict, "challenge_request_key", "creq");
                      var transStatus = Utils$OrcaPaymentPage.getString(dict, "trans_status", "Y");
                      var acsUrl = Utils$OrcaPaymentPage.getString(dict, "acs_url", "");
                      var ele = document.querySelector("#threeDsAuthDiv");
                      LoggerUtils$OrcaPaymentPage.handleLogging(logger, transStatus, "DISPLAY_THREE_DS_SDK", "CARD", undefined);
                      if (!(ele == null)) {
                        if (transStatus === "C") {
                          setloader(function (param) {
                                return false;
                              });
                          var form = Utils$OrcaPaymentPage.makeForm(ele, acsUrl, "3dsChallenge");
                          var input = document.createElement("input");
                          input.name = challengeRequestKey;
                          input.value = creq;
                          form.target = "threeDsAuthFrame";
                          form.appendChild(input);
                          form.submit();
                        } else {
                          handleFrictionLess();
                        }
                      }
                      return Promise.resolve(json);
                    }), (function (err) {
                    var exceptionMessage = Utils$OrcaPaymentPage.formatException(err);
                    LoggerUtils$OrcaPaymentPage.handleLogging(logger, JSON.stringify(exceptionMessage), "DISPLAY_THREE_DS_SDK", "CARD", "ERROR");
                    var errorObj = PaymentError$OrcaPaymentPage.itemToObjMapper(dict);
                    Utils$OrcaPaymentPage.postFailedSubmitResponse(errorObj.error.type_, errorObj.error.message);
                    return Promise.resolve(null);
                  }));
          };
          window.addEventListener("message", handle);
          return (function () {
                    window.removeEventListener("message", handle);
                  });
        }), []);
  React.useEffect((function () {
          if (expiryTime < 1000.0) {
            handleFrictionLess();
          }
          var intervalID = setInterval((function () {
                  setExpiryTime(function (prev) {
                        return prev - 1000.0;
                      });
                }), 1000);
          return (function () {
                    clearInterval(intervalID);
                  });
        }), [expiryTime]);
  return React.createElement(Modal$OrcaPaymentPage.make, {
              children: React.createElement("div", {
                    className: "backdrop-blur-xl"
                  }, React.createElement("div", {
                        className: "hidden",
                        id: "threeDsAuthDiv"
                      }), React.createElement("iframe", {
                        id: "threeDsAuthFrame",
                        style: {
                          minHeight: "500px",
                          outline: "none"
                        },
                        title: "3D Secure Authentication Frame",
                        name: "threeDsAuthFrame",
                        width: "100%"
                      })),
              closeCallback: handleFrictionLess,
              loader: match$1[0],
              setOpenModal: match[1],
              openModal: match[0]
            });
}

var make = ThreeDSAuth;

export {
  make ,
}
/* react Not a pure module */
